import { render, staticRenderFns } from "./TipoCertificadoPage.vue?vue&type=template&id=9d892474"
import script from "./TipoCertificadoPage.js?vue&type=script&lang=js&external"
export * from "./TipoCertificadoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports